import {
    Button,
    ButtonGroup,
    Card,
    Checkbox,
    DataTable,
    EmptyState,
    Icon,
    Spinner,
    Stack,
    TextField,
    Popover,
    ActionList,
    TextStyle,
    TextContainer,
    ResourceList,
    ResourceItem,
    Modal,
    Thumbnail,
    Filters,
    DescriptionList,
    ChoiceList,
} from "@shopify/polaris"
import formatDateTime from "../../utils/formatDateTime"
import { DeleteMinor, EditMinor, SearchMinor, ViewMinor } from "@shopify/polaris-icons"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../actions"
import axios from "../../funcs/axios"
function mapStateToProps(state) {
    return {
        app_settings: state.app_settings,
        app_render: state.app_render,
        app_edited: state.app_edited,
        plan: state.plan,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}
class Contact extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listCheckbox: [],
            checkAll: false,
            contacts: [],
            selected: [],
            loading: true,
            textSearch: "",
            active: false,
            viewActive: false,
            itemView: {},
            sort: [],
            activeDelete: false,
            itemDelete: false,
            checkDeleteBulk: false,
        }
        this.loadContacts()
    }

    loadContacts() {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/load-notifications`).then((res) => {
            let data = res.data.notifications
            let listContact = []
            data.map((e) => {
                listContact.push(e)
            })
            console.log(`listContact`, listContact)
            this.setState({ contacts: listContact, loading: false })
        })
    }

    handleCheckAll = () => {
        const { contacts, checkAll } = this.state
        let newListCheckbox = []
        if (!checkAll) {
            contacts.map((item, index) => {
                let data = {
                    id: item.create_at,
                }
                return newListCheckbox.push(data)
            })
        }
        this.setState({ listCheckbox: newListCheckbox })
        this.setState({ checkAll: !checkAll })
    }

    checkItemExistsInArray = (array, id) => {
        if (!array.length) return false
        for (let i = 0; i < array.length; i++) {
            if (array[i].id == id) {
                return true
            }
        }
        return false
    }

    handleChangeProductsSelected = (id) => {
        const { listCheckbox, contacts } = this.state
        let newListCheckbox = [...listCheckbox]
        let data = {
            id,
        }
        let flag = this.checkItemExistsInArray(newListCheckbox, id)
        if (flag) {
            newListCheckbox = newListCheckbox.filter((item) => item.id != id)
        } else {
            newListCheckbox.push(data)
        }
        if (newListCheckbox.length === contacts.length) this.setState({ checkAll: true })
        else this.setState({ checkAll: false })
        this.setState({ listCheckbox: newListCheckbox })
    }

    toggleActive = () => {
        this.setState({ active: !this.state.active })
    }

    viewContact = (e) => {
        this.setState({ viewActive: true, itemView: e })
    }

    handleChange = () => {
        this.setState({ viewActive: false })
    }

    renderViewContact = () => {
        const { viewActive, itemView } = this.state
        return (
            <Modal
                open={viewActive}
                onClose={() => this.handleChange()}
                title="Contact details"
                secondaryActions={[
                    {
                        content: "Cancel",
                        onAction: () => this.handleChange(),
                    },
                ]}
            >
                <Modal.Section>
                    <TextContainer>
                        <DescriptionList
                            items={[
                                {
                                    term: "Notifications",
                                    description: "0 notifications",
                                },
                                {
                                    term: "Products",
                                    description: "0 demand products",
                                },
                            ]}
                        />
                    </TextContainer>
                </Modal.Section>
                <Modal.Section>
                    <TextContainer>
                        <ResourceList
                            items={itemView.notifications}
                            renderItem={(item) => {
                                const { image, titleVariant, title, productUrl } = item
                                return (
                                    <ResourceItem
                                        verticalAlignment="center"
                                        media={
                                            <Thumbnail
                                                size="medium"
                                                source={"https://" + image}
                                            ></Thumbnail>
                                        }
                                    >
                                        {/* <Stack distribution="fillEvenly" alignment="center">
                                           
                                        </Stack> */}
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <a href={productUrl} target="_blank">
                                                <TextStyle>{title}</TextStyle>
                                            </a>
                                            <p>
                                                <TextStyle>{titleVariant}</TextStyle>
                                            </p>
                                        </div>
                                    </ResourceItem>
                                )
                            }}
                        ></ResourceList>
                    </TextContainer>
                </Modal.Section>
            </Modal>
        )
    }

    deleteContact = (item) => {
        let array = []
        array.push(item)
        this.setState({ listCheckBox: [] })
        axios.post(`${window.SHOPIFY_APP_HOST}/admin/delete-contacts`, array).then((res) => {
            console.log(`res`, res)
            if (res.data.status == "success") {
                this.props.actions.AppNotify({
                    content: res.data.msg,
                    show: true,
                    error: false,
                })
                this.setState({ activeDelete: false })
                this.loadContacts()
            } else {
                this.props.actions.AppNotify({
                    content: res.data.msg,
                    show: true,
                    error: true,
                })
                this.setState({ activeDelete: false })
            }
        })
    }

    deleteBulkContacts = () => {
        const { listCheckbox, contacts } = this.state
        let array = []
        listCheckbox.map((item) => {
            let idx = contacts.findIndex((e) => e.create_at == item.id)
            if (contacts[idx]) array.push(contacts[idx])
        })
        this.setState({ listCheckBox: [] })
        axios.post(`${window.SHOPIFY_APP_HOST}/admin/delete-contacts`, array).then((res) => {
            if (res.data.status == "success") {
                this.props.actions.AppNotify({
                    content: res.data.msg,
                    show: true,
                    error: false,
                })
                this.setState({ activeDelete: false })
                this.loadContacts()
            } else {
                this.props.actions.AppNotify({
                    content: res.data.msg,
                    show: true,
                    error: true,
                })
                this.setState({ activeDelete: false })
            }
        })
    }

    isEmpty(value) {
        if (Array.isArray(value)) {
            return value.length === 0
        } else {
            return value === "" || value == null
        }
    }

    handleSearch = (keyword) => (e) => e.email.toLowerCase().includes(keyword.toLowerCase())

    handleSort = (type) => (a, b) => {
        switch (type.toString()) {
            case "Contact (ascending)":
                if (a.email > a.email) {
                    return 1
                }
                if (a.email > a.email) {
                    return -1
                }
                break
            case "Contact (descending)":
                if (a.email > b.email) {
                    return -1
                }
                if (b.email > a.email) {
                    return 1
                }
                break
            case "Date (oldest first)":
                return a.create_at - b.create_at
            case "Date (newest first)":
                return b.create_at - a.create_at
            default:
                return a.email - b.email
        }
    }

    renderModalDelete = () => {
        const { activeDelete, itemDelete, checkDeleteBulk } = this.state
        return (
            <Modal
                open={activeDelete}
                onClose={() => this.setState({ activeDelete: false, checkDeleteBulk: false })}
                title="Delete contacts?"
                primaryAction={{
                    content: "Delete",
                    onAction: () =>
                        checkDeleteBulk
                            ? this.deleteBulkContacts()
                            : this.deleteContact(itemDelete),
                }}
                secondaryActions={[
                    {
                        content: "Cancel",
                        onAction: () =>
                            this.setState({ activeDelete: false, checkDeleteBulk: false }),
                    },
                ]}
            >
                <Modal.Section>
                    <TextContainer>
                        <p>Are you sure you want to delete contact? This can't be undone.</p>
                    </TextContainer>
                </Modal.Section>
            </Modal>
        )
    }

    render() {
        const { active, checkAll, listCheckbox, loading, textSearch, sort } = this.state
        let { contacts } = this.state
        contacts = contacts.filter(this.handleSearch(textSearch))
        contacts = contacts.sort(this.handleSort(sort))
        const activator = (
            <Button onClick={() => this.toggleActive()} disclosure>
                Actions
            </Button>
        )

        let rows = [],
            heading = [
                <Checkbox onChange={() => this.handleCheckAll()} checked={checkAll} />,
                "Email",
                "Date",
                "Action",
            ]

        for (let i = 0; i < contacts.length; i++) {
            let array = []
            array.push(
                <Checkbox
                    onChange={() => this.handleChangeProductsSelected(contacts[i].create_at)}
                    checked={this.checkItemExistsInArray(listCheckbox, contacts[i].create_at)}
                />,
            )
            array.push(
                <h3>
                    <TextStyle>{contacts[i].email}</TextStyle>
                </h3>,
            )
            array.push(
                <h3>
                    <TextStyle>{formatDateTime(contacts[i].create_at, "Month DD, YYYY")}</TextStyle>
                </h3>,
            )
            array.push(
                <ButtonGroup segmented>
                    <Button
                        icon={<Icon source={ViewMinor} />}
                        size="slim"
                        onClick={() => this.viewContact(contacts[i])}
                    ></Button>
                    <Button
                        onClick={() => {
                            this.setState({ activeDelete: true, itemDelete: contacts[i] })
                        }}
                        destructive
                        icon={<Icon source={DeleteMinor} />}
                        size="slim"
                    ></Button>
                </ButtonGroup>,
            )
            rows.push(array)
        }

        if (listCheckbox.length) {
            heading = []
            heading.push(
                <ButtonGroup segmented>
                    <Button
                        icon={
                            <Checkbox onChange={() => this.handleCheckAll()} checked={checkAll} />
                        }
                        onClick={() => this.handleCheckAll()}
                    >
                        {listCheckbox.length} selected
                    </Button>
                    <Popover
                        active={active}
                        activator={activator}
                        onClose={() => this.toggleActive()}
                    >
                        <ActionList
                            items={[
                                {
                                    content: "Delete",
                                    onAction: () =>
                                        this.setState({
                                            checkDeleteBulk: true,
                                            activeDelete: true,
                                        }),
                                },
                            ]}
                        />
                    </Popover>
                </ButtonGroup>,
            )

            if (document.getElementsByTagName("th")[0]) {
                let th = document.getElementsByTagName("th")[0]
                th.setAttribute("colspan", 7)
            }
        } else {
            if (document.getElementsByTagName("th")[0]) {
                let th = document.getElementsByTagName("th")[0]
                th.removeAttribute("colspan")
            }
        }

        const appliedFilters = []
        if (!this.isEmpty(sort)) {
            const key = "Sort"
            appliedFilters.push({
                key,
                label: sort,
                onRemove: () => this.setState({ sort: [] }),
            })
        }

        const filters = [
            {
                key: "Sort",
                label: "Sort",
                filter: (
                    <ChoiceList
                        title="Availability"
                        titleHidden
                        choices={[
                            { label: "Contact (ascending)", value: "Contact (ascending)" },
                            { label: "Contact (descending)", value: "Contact (descending)" },
                            { label: "Date (oldest first)", value: "Date (oldest first)" },
                            { label: "Date (newest first)", value: "Date (newest first)" },
                        ]}
                        selected={sort || []}
                        onChange={(val) => this.setState({ sort: val })}
                    />
                ),
                shortcut: true,
            },
        ]
        const disableStyle =
            this.props.plan.plan == "free" ? { opacity: 0.5, pointerEvents: "none" } : {}
        return (
            <div className="body-plan-pro">
                <div style={disableStyle}>
                    {this.renderModalDelete()}
                    {this.renderViewContact()}
                    {!loading ? (
                        <Card>
                            <Card.Section>
                                <Filters
                                    queryPlaceholder="Filter contacts by email"
                                    queryValue={textSearch}
                                    filters={filters}
                                    appliedFilters={appliedFilters}
                                    onQueryChange={(val) => this.setState({ textSearch: val })}
                                    onQueryClear={() => this.setState({ textSearch: "" })}
                                    // onClearAll={handleFiltersClearAll}
                                />
                            </Card.Section>
                            {contacts.length ? (
                                <Card.Section>
                                    <DataTable
                                        columnContentTypes={[
                                            "text",
                                            "text",
                                            "text",
                                            "text",
                                            "text",
                                            "text",
                                            "text",
                                        ]}
                                        headings={heading}
                                        rows={rows}
                                    ></DataTable>
                                </Card.Section>
                            ) : (
                                <Card.Section>
                                    <Card.Section>
                                        <EmptyState
                                            heading="No product in pre-order"
                                            image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
                                        >
                                            <p>
                                                We couldn't find any result. Please add to product
                                                pre-order
                                            </p>
                                        </EmptyState>
                                    </Card.Section>
                                </Card.Section>
                            )}
                        </Card>
                    ) : (
                        <Stack distribution="center">
                            <div style={{ marginTop: "20px", display: "flex" }}>
                                <Spinner
                                    accessibilityLabel="Loading more customers"
                                    size="large"
                                    color="teal"
                                />
                            </div>
                        </Stack>
                    )}
                </div>

                {this.props.plan.plan == "free" && (
                    <span className="tooltiptext">Please upgrade to use this feature</span>
                )}
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Contact)
